import { useContext } from "react";
import { VscDebugStackframe } from "react-icons/vsc";
import useScrollWindow from "../../../../hooks/scrollWindow";
import searchContext from "../../../../dataManager/context/searchContext";
import categoriesContext from "../../../../dataManager/context/categoriesContext";
import LoaderBox from "../../../utils/loadersBox/LoaderBox";
import InputRange from "../../../elements/form/InputRange";
import ButtonHref from "../../../elements/buttons/ButtonHref";
import { MAX_PRISE } from "../../../../datas/constantsValues";

const Aside = () => {
  //context variables
  const { priceRange, setPriceRange, addFilters } = useContext(searchContext);
  const { categories } = useContext(categoriesContext);

  //value while scrolling the banner is going hidden
  const SCROLL_MAX_Y = 500;

  // get the current scroll value
  const [scrollPositionY] = useScrollWindow();

  const allLoadrBox = (
    <>
      <LoaderBox classe="w-full" />
      <LoaderBox classe="w-[85%]" />
      <LoaderBox classe="w-[75%]" />
      <LoaderBox classe="w-[68%]" />
    </>
  );

  return (
    <aside
      className={`${
        scrollPositionY > SCROLL_MAX_Y ? "top-[106px]" : "top-[150px]"
      } top-[150px] hidden w-[210px] shrink-0 rounded md:mt-44 lg:sticky lg:block lg:w-[280px]  lg:px-2`}
    >
      <h3 className="font-nunito text-[1.4rem] font-semibold text-secondary  ">
        Catégories d'articles
      </h3>
      <ul className="mt-2 flex flex-col space-y-5">
        {categories.length === 0
          ? allLoadrBox
          : categories
              .slice(0, 8)
              .map((category) => (
                <CategoryButton
                  categoryName={category.getName}
                  onAddCategoryToFilter={addFilters}
                />
              ))}
      </ul>

      <div className="mt-3">
        <InputRange
          labelName={`Prix (${priceRange}) fcfa`}
          min={50000}
          max={MAX_PRISE}
          step={2000}
          value={priceRange}
          onChange={setPriceRange}
        />
      </div>
      <ButtonHref
        classe={` mt-2`}
        target="_blank"
        href="https://wa.me/237674651112"
      >
        Nous contacter
      </ButtonHref>
    </aside>
  );
};

const CategoryButton = ({ categoryName, onAddCategoryToFilter }) => {
  return (
    <li
      onClick={() => onAddCategoryToFilter(categoryName)}
      className="group flex cursor-pointer items-center space-x-2 text-secondary lg:space-x-2"
    >
      <VscDebugStackframe className="animate block font-bold group-hover:text-primary" />
      <span className="block font-nunito text-xs font-medium  lg:text-base">
        {categoryName}
      </span>
    </li>
  );
};

export default Aside;
